//IMPORTING COLORS
import {
  WHITE,
  TEXT_COLOR,
  PRIMARY_BTN_COMETAS,
  TITLE_COLOR_COMETAS,
  ICON_COLOR_COMETAS,
  FADE_BG_COMETAS,
  LIGHT_BG_COMETAS,
  FOOTER_BG_COMETAS,
} from "../../utils/colors";

//IMPORTING FONT
import {
  TITLE_SIZE,
  SUB_TITLE_SIZE,
  TEXT_SIZE,
  SUB_TEXT_SIZE,
} from "../../utils/fonts";

import { useEffect } from "react";
import DynamicTitle from "../../components/DynamicTitle";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import CustomButton from "../../components/CustomButton";
import BannerSection from "../../components/BannerSection";
import BannerAbout from "../../components/BannerAbout";
import { PiHandsPraying } from "react-icons/pi";
import LogoCometas from "../../assets/logo/logo-pequenos-cometas.png";
import JoinUsCall from "../../components/JoinUsCall";
import LocationCall from "../../components/LocationCall";
import FooterBar from "../../components/FooterBar";
import { PiMeteorBold } from "react-icons/pi";
import CometasImg from "../../assets/images/cometas-img.webp";
import { LuHeart } from "react-icons/lu";
import { LuCircleCheckBig } from "react-icons/lu";
import CometasImg2 from "../../assets/images/cometas-img-2.png";
import CometasImg3 from "../../assets/images/cometas-img-3.png";
import { TbMapShare } from "react-icons/tb";
import RecentPosts from "../../components/RecentPostsCall";
import { LiaDoveSolid } from "react-icons/lia";
import { FiPhone } from "react-icons/fi";
import Cometas from "../../assets/images/cometas-wallpaper.webp";
import CometasMob from "../../assets/images/cometas-wallpaper-mob.webp";
import "./PequenosCometas.css";

export default function PequenosCometas() {
  const fileUrlCometas = "/termo-de-compromisso.pdf";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <DynamicTitle
        pageTitle="Grupo Krause - Pequenos Cometas"
        pageMeta="Pequenos Cometas"
        pageContent="O Pequenos Cometas é um projeto social que garante serviço funerário gratuito a crianças com idade inferior a 10 anos para a região do Vale dos Sinos."
      />
      <BannerSection
        white={WHITE}
        fadeBG={FADE_BG_COMETAS}
        iconTitle={
          <PiHandsPraying
            style={{ color: WHITE }}
            className="banner-section-icon"
          />
        }
        bannerTitle={"PROJETO SOCIAL PEQUENOS COMETAS"}
        bannerTitleSize={TITLE_SIZE}
        bannerSubTitle={
          "Toda família merece se despedir de seus pequenos cometas."
        }
        bannerSubTitleSize={SUB_TITLE_SIZE}
        bannerBG={Cometas}
        bannerBGmobile={CometasMob}
      />
      <BannerAbout
        companyBrand={LogoCometas}
        firstText={`Nada pode ser mais difícil que a perda de um filho.
                  O falecimento de uma criança inverte a ordem natural da vida 
                  e coloca famílias em uma dor inimaginável. Para oferecer apoio nesse momento de tristeza, a Funerária Krause criou o projeto Pequenos Cometas.`}
        secondText={""}
        textColor={TEXT_COLOR}
        textSize={TEXT_SIZE}
      />
      <Container className="cometas-section">
        <Row>
          <Col className="cometas-first-col-sm">
            <PiMeteorBold
              style={{ color: ICON_COLOR_COMETAS }}
              className="cometas-icon"
            />
            <h2 style={{ color: TITLE_COLOR_COMETAS, fontSize: TITLE_SIZE }}>
              O QUE É O PEQUENOS COMETAS?
            </h2>
          </Col>
        </Row>
        <Row>
          <Col lg={6} className="cometas-third-col">
            <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
              O Pequenos Cometas é um projeto social que garante serviço
              funerário gratuito a crianças com idade inferior a 10 anos.
            </p>
            <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
              A iniciativa tem o objetivo de ajudar famílias de Novo Hamburgo e
              outras cidades da região, oferecendo apoio para que possam prestar
              uma homenagem aos seus cometas que vieram, brilharam por um curto
              período de tempo e partiram.
            </p>
            <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
              A ação cobre todos os custos com o funeral, levando ao menos um
              pouco de alívio para as famílias enfrentarem essa perda.
            </p>
            <CustomButton
              className="primary-btn"
              variant="primary"
              href={fileUrlCometas}
              rel="noopener noreferrer"
              target="_blank"
              icon=""
              content="TERMO DE COMPROMISSO"
              backgroundColor={PRIMARY_BTN_COMETAS}
              fontFamily="Unageo-Bold"
              fontColor={WHITE}
              fontSize={18}
              width={280}
              borderColor={PRIMARY_BTN_COMETAS}
              disabled={false}
            />
          </Col>
          <Col lg={{ span: 6, order: "first" }} className="cometas-second-col">
            <div className="cometas-img-container">
              <img src={CometasImg} alt="Menino como anjo" />
              <div className="cometas-img-overlay" />
            </div>
          </Col>
        </Row>
      </Container>
      <Container className="cometas-details-section">
        <Row>
          <Col className="cometas-first-col">
            <h2 style={{ color: TITLE_COLOR_COMETAS, fontSize: TITLE_SIZE }}>
              <LuHeart
                style={{ color: ICON_COLOR_COMETAS }}
                className="cometas-details-icon"
              />
              DETALHES
            </h2>
          </Col>
        </Row>
        <Row>
          <Col className="cometas-contact-sub-text">
            <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
              Materiais e serviços disponibilizados gratuitamente
            </p>
          </Col>
        </Row>
        <Row>
          <Col lg={7} className="cometas-details-second-col">
            <div className="cometas-details-item">
              <LuCircleCheckBig
                style={{ color: ICON_COLOR_COMETAS }}
                className="cometas-details-item-icon"
              />
              <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>Véu</p>
            </div>
            <div className="cometas-details-item">
              <LuCircleCheckBig
                style={{ color: ICON_COLOR_COMETAS }}
                className="cometas-details-item-icon"
              />
              <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
                Urna mortuária infantil
              </p>
            </div>
            <div className="cometas-details-item">
              <LuCircleCheckBig
                style={{ color: ICON_COLOR_COMETAS }}
                className="cometas-details-item-icon"
              />
              <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
                Serviços gerais de carro fúnebre
              </p>
            </div>
            <div className="cometas-details-item">
              <LuCircleCheckBig
                style={{ color: ICON_COLOR_COMETAS }}
                className="cometas-details-item-icon"
              />
              <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
                Velas e paramentos para velório, de acordo com a religião
              </p>
            </div>
            <div className="cometas-details-item">
              <LuCircleCheckBig
                style={{ color: ICON_COLOR_COMETAS }}
                className="cometas-details-item-icon"
              />
              <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
                Flores para ornamentação da urna, artificiais ou naturais
                conforme disponibilidade
              </p>
            </div>
            <div className="cometas-details-item">
              <LuCircleCheckBig
                style={{ color: ICON_COLOR_COMETAS }}
                className="cometas-details-item-icon"
              />
              <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
                Translado de até 100 (cem) quilômetros rodados, tendo como ponto
                de partida as cidades onde o Grupo Krause possuir filial
              </p>
            </div>
            <div className="cometas-details-item">
              <LuCircleCheckBig
                style={{ color: ICON_COLOR_COMETAS }}
                className="cometas-details-item-icon"
              />
              <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
                Higienização, assepsia e/ou tanatopraxia, de acordo com a
                necessidade do caso (a critério da Funerária Krause)
              </p>
            </div>
            <div className="cometas-details-item">
              <LuCircleCheckBig
                style={{ color: ICON_COLOR_COMETAS }}
                className="cometas-details-item-icon"
              />
              <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
                Sala de velório de propriedade do Grupo Krause, havendo
                disponibilidade. Nas demais cidades, o serviço será realizado em
                salas de velórios municipais
              </p>
            </div>
          </Col>
          <Col lg={5} className="cometas-details-third-col">
            <img
              src={CometasImg2}
              alt="Entrega de flor"
              className="cometas-details-img"
            />
            <img
              src={CometasImg3}
              alt="Criança olhando um rio"
              className="cometas-details-img-lg"
            />
          </Col>
        </Row>
      </Container>
      <Container>
        <Row>
          <Col className="cometas-first-col">
            <h2 style={{ color: TITLE_COLOR_COMETAS, fontSize: TITLE_SIZE }}>
              <TbMapShare
                style={{ color: ICON_COLOR_COMETAS }}
                className="cometas-details-icon"
              />
              CIDADES ATENDIDAS
            </h2>
          </Col>
        </Row>
      </Container>
      <Container fluid className="cometas-location-section">
        <Row>
          <Col className="cometas-location-second-col">
            <h3 style={{ color: WHITE, fontSize: SUB_TITLE_SIZE }}>
              Novo Hamburgo - RS
            </h3>
            <h3 style={{ color: WHITE, fontSize: SUB_TITLE_SIZE }}>
              São Leopoldo - RS
            </h3>
            <h3 style={{ color: WHITE, fontSize: SUB_TITLE_SIZE }}>
              Campo Bom - RS
            </h3>
            <h3 style={{ color: WHITE, fontSize: SUB_TITLE_SIZE }}>
              Sapiranga - RS
            </h3>
            <h3 style={{ color: WHITE, fontSize: SUB_TITLE_SIZE }}>
              Estância Velha - RS
            </h3>
            <h3 style={{ color: WHITE, fontSize: SUB_TITLE_SIZE }}>
              Dois Irmãos - RS
            </h3>
            <h3 style={{ color: WHITE, fontSize: SUB_TITLE_SIZE }}>
              Ivoti - RS
            </h3>
          </Col>
        </Row>
      </Container>
      <Container>
        <Row>
          <Col className="cometas-first-col">
            <FiPhone
              style={{ color: ICON_COLOR_COMETAS }}
              className="cometas-details-icon"
            />
            <h2 style={{ color: TITLE_COLOR_COMETAS, fontSize: TITLE_SIZE }}>
              CONTATO
            </h2>
          </Col>
        </Row>
        <Row>
          <Col className="cometas-contact-sub-text">
            <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
              Para saber mais sobre o projeto social Pequenos Cometas, entre em
              contato através dos nossos canais.
            </p>
          </Col>
        </Row>
      </Container>
      <Container fluid className="cometas-contact-container">
        <div className="cometas-contact-bg">
          <Container>
            <Row>
              <Col>
                <a
                  style={{ color: WHITE, fontSize: SUB_TITLE_SIZE }}
                  href="tel:05130369660"
                  className="cometas-contact-link"
                >
                  <LiaDoveSolid className="cometas-contact-link-icon" />
                  <p>
                    Em caso de solicitação do serviço funerário ligue para (51)
                    3036.9660
                  </p>
                </a>
              </Col>
            </Row>
          </Container>
        </div>
      </Container>
      <RecentPosts
        white={WHITE}
        iconColor={ICON_COLOR_COMETAS}
        titleColor={TITLE_COLOR_COMETAS}
        textColor={TEXT_COLOR}
        btnColor={ICON_COLOR_COMETAS}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        subTitleSize={SUB_TITLE_SIZE}
        subTextSize={SUB_TEXT_SIZE}
      />
      <LocationCall
        white={WHITE}
        iconColor={ICON_COLOR_COMETAS}
        titleColor={TITLE_COLOR_COMETAS}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        fadeBG={FADE_BG_COMETAS}
      />
      <JoinUsCall
        white={WHITE}
        iconColor={ICON_COLOR_COMETAS}
        titleColor={TITLE_COLOR_COMETAS}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        fadeBG={FADE_BG_COMETAS}
        circleBG={LIGHT_BG_COMETAS}
        btnColor={PRIMARY_BTN_COMETAS}
      />
      <FooterBar
        titleColor={TITLE_COLOR_COMETAS}
        footerBarBG={FOOTER_BG_COMETAS}
      />
    </div>
  );
}
